import SSO from '../../libs/sso/sso'
import * as types from '../mutation-types'
import ajax from 'api/userauth'

const state = {
  loggedIn: false,
  hasModal: false,
  email: '',
  mobile: '',
  nickname: '',
  level:'L0',
  isCertificated: '',
  certificateDesc: '未实名认证',
  certificateType: '2', // 1：个人（包括个人和学生）；2：企业；3：创业；4：未通过；5：审核中
  errors: [],
  loggedInCallback: () => {
    // 登录回调
  },
  // 认证类型就是认证类型 不知道历史代码中为什么要用一个字段既代表认证类型，又用4、5表达审核状态
  // 老的字段不敢动，现实名认证表单相关页面使用新的字段做判断，规则如下：
  // 认证方式 authType（1-普通个人 2-在校大学生 3-社会信用代码 *4-营业执照 5-非营利组织 *6-其他认证材料）
  // 4、6 只为兼容老数据
  // 认证类型 type:（1-个人，2-企业，3-创业团队）
  // 个人又分为普通个人（1）和学生（2），企业又分为企业（3）和组织（5），创业团队只需要 type 来判断即可
  // 下面3个字段似乎用不到了
  type: 2,
  authType: 3,
  status: 0,
  certificationInfo: {}, // 认证信息的汇总，已解不时之需
  certificationData: {}, // 接口的直接返回
}

const getters = {
  getLogin: state => state.loggedIn,
}

const actions = {
  beginLogin({ commit }, loggedInCallback) {
    commit(types.BEGIN_LOGIN, loggedInCallback)
  },
  setUserInfo({ commit }) {
    ajax.getUserDetailInfo().then(data => {
      ajax.getUserWeixinGuide().then(res => {
        if (data && data.flag) {
          commit(types.SET_USER_INFO, data.data)
        }
      })
    })
  },
  setCertificateInfo({ commit }, callback) {
    ajax.getAuthStatus().then(status => {
      ajax.getAuthInfo().then(data => {
        commit(types.SET_CERTIFICATE_INFO, { status, data, callback })
      })
    })
  },
  logout({ commit }) {
    ajax.logout().then(() => {
      SSO.logout(() => {
        // 登出回调
        commit(types.LOGOUT)
        location.href=Url[Mode].baseUrl
      })
    })
  },
  endLogin({ commit }) {
    commit(types.END_LOGIN)
  },
  setUserEmail({ commit }, status) {
    commit(types.SET_USER_EMAIL_INFO, status)
  },
  setLevel({ commit }) {
    ajax.getLevel().then(res => {
      commit(types.SET_LEVEL, res.data ? res.data.labelName : 0)
    })
  },
}

const mutations = {
  [types.BEGIN_LOGIN](state, loggedInCallback) {
    state.hasModal = true
    state.loggedInCallback = loggedInCallback
  },
  [types.SET_USER_EMAIL_INFO](state, status) {
    state.email = status
  },
  [types.SET_USER_INFO](state, user) {
    state.loggedIn = true
    state.hasModal = false
    state.email = user.email
    state.mobile = user.mobile
    state.nickname = user.nickname
  },
  [types.SET_CERTIFICATE_INFO](state, { status, data, callback }) {
    // 加个接口的直接返回，方便相关页面进行细致的逻辑处理
    state.certificationData = data
    if (status && !status.flag) {
      state.isCertificated = false
      if (data && data.data) {
        let certificateInfo = data.data
        state.certificationInfo = certificateInfo
        state.type = certificateInfo.type
        state.authType = certificateInfo.authType
        state.status = certificateInfo.status
        if (certificateInfo.status == '0') {
          state.certificateDesc = '实名认证未通过'
          state.certificateType = '4'
        }
        if (certificateInfo.status == '2') {
          state.certificateDesc = '实名认证审核中'
          state.certificateType = '5'
        }
      }
    } else {
      state.isCertificated = true
      if (data && data.flag) {
        let certificateInfo = data.data
        state.certificationInfo = certificateInfo
        state.type = certificateInfo.type
        state.authType = certificateInfo.authType
        state.status = certificateInfo.status
        state.certificateDesc = '企业认证'
        state.certificateType = certificateInfo.type
        if (certificateInfo.type == '1') {
          if (certificateInfo.authType == '1') {
            state.certificateDesc = '个人认证'
          }
          if (certificateInfo.authType == '2') {
            state.certificateDesc = '学生认证'
          }
        } else if (certificateInfo.type == '3') {
          state.certificateDesc = '创业团队认证'
        }
      }
    }
    if (typeof (callback) === 'function') callback()
  },
  [types.END_LOGIN](state) {
    state.hasModal = false
  },
  [types.LOGIN_SUCCESS](state, user) {
    state.loggedIn = true
    state.hasModal = false
    state.email = user.email
    state.nickname = user.nickname
    state.errors = []
    // 仅在通过路由传入 next 回调时执行跳转至新页面逻辑
    // 通过点击登录按钮登录时该参数非函数
    if (typeof state.loggedInCallback === 'function') {
      state.loggedInCallback()
    }
  },
  [types.LOGIN_FAIL](state, errInfo) {
    state.errors.push(errInfo)
  },
  [types.LOGOUT](state, errInfo) {
    state.loggedIn = false
    // state.hasModal = false
    state.errors = []
    state.email = ''
    state.loggedInCallback = () => {
      // 登录回调
    }
  },
  [types.SET_LEVEL](state, info) {
    state.level = info
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./app/store/modules/auth.js